import { t } from '../copy'

/**
 * 导航注册表。2026-08-25 三端统一架构批次。
 *
 * 规范来源：`导航菜单规范-三端.html`
 * 三端（Web / macOS / App）读同一份 registry。
 *
 * 七项全局扁平不分组：Lulu / 项目 / 发布 / 资源 / 备忘录 / AI 团队 / 动态。
 * mobileMore=true 的项在 App 侧滑收进「更多」折叠区。
 * 设置类屏（安全体检/服务商/模型/AI接口/告警/成员）全移入账户菜单。
 */

export type ScreenKey =
  | 'chat' | 'project' | 'code' | 'hosts' | 'memo' | 'skills' | 'timeline'
  | 'dash' | 'sec' | 'models' | 'bridge' | 'vendor' | 'alert' | 'team'
  | 'auth' | 'account' | 'server' | 'onboard'

export interface NavRegistryEntry {
  key: ScreenKey
  path: string
  order: number
  scope: 'global' | 'account' | 'hidden'
  mobileMore: boolean
}

export const NAV_REGISTRY: NavRegistryEntry[] = [
  // ---- 顶栏七项 ----
  // key 仍是 'chat'（文案 id `nav.chat` = 「Lulu」、图标、高亮都挂在它上面），
  // **path 指向 `/lulu`**。2026-08-26 生产验收：点顶栏 Lulu 进 `/chat`，
  // 主区完全空白——旧屏的后端不在 main 上，而新工作台在 `/lulu` 是好的。
  // 冻结合同本来就写着「根路由和 /lulu 都进入 Lulu」，这条是最后一个没跟上的入口。
  { key: 'chat',     path: '/lulu',       order: 1, scope: 'global', mobileMore: false },
  { key: 'project',  path: '/projects',   order: 2, scope: 'global', mobileMore: false },
  { key: 'code',     path: '/code',       order: 3, scope: 'global', mobileMore: true },
  { key: 'hosts',    path: '/hosts',      order: 4, scope: 'global', mobileMore: true },
  { key: 'memo',     path: '/memos',      order: 5, scope: 'global', mobileMore: false },
  { key: 'skills',   path: '/skills',     order: 6, scope: 'global', mobileMore: true },
  { key: 'timeline', path: '/activity',   order: 7, scope: 'global', mobileMore: false },

  // ---- 账户菜单 ----
  { key: 'account',  path: '/account',    order: 1, scope: 'account', mobileMore: false },
  { key: 'team',     path: '/team',       order: 2, scope: 'account', mobileMore: false },
  { key: 'sec',      path: '/security',   order: 3, scope: 'account', mobileMore: false },
  { key: 'vendor',   path: '/vendors',    order: 4, scope: 'account', mobileMore: false },
  { key: 'models',   path: '/models',     order: 5, scope: 'account', mobileMore: false },
  { key: 'bridge',   path: '/bridge',     order: 6, scope: 'account', mobileMore: false },
  { key: 'alert',    path: '/alerts',     order: 7, scope: 'account', mobileMore: false },

  // ---- 隐藏 ----
  { key: 'dash',     path: '/',            order: 0, scope: 'hidden', mobileMore: false },
  { key: 'server',   path: '/hosts/$hostId', order: 0, scope: 'hidden', mobileMore: false },
  { key: 'onboard',  path: '/hosts/new',  order: 0, scope: 'hidden', mobileMore: false },
  { key: 'auth',     path: '/auth',       order: 0, scope: 'hidden', mobileMore: false },
]

export const TOP_NAV = NAV_REGISTRY
  .filter((e) => e.scope === 'global')
  .sort((a, b) => a.order - b.order)

export const DRAWER_PRIMARY = TOP_NAV.filter((e) => !e.mobileMore)
export const DRAWER_MORE = TOP_NAV.filter((e) => e.mobileMore)
export const ACCOUNT_NAV = NAV_REGISTRY
  .filter((e) => e.scope === 'account')
  .sort((a, b) => a.order - b.order)

export function screenLabel(key: ScreenKey): string {
  return t(`nav.${key}`)
}
